const constants = {
    LOGIN_LOADING: 'login_loading',
    LOGIN_SUCCESS: 'login_success',
    LOGIN_FAIL: 'login_fail',
    RESET_LOADING: 'reset_loading',
    RESET_SUCCESS: 'reset_success',
    RESET_FAIL: 'reset_fail',
    REQUEST_RESET_LOADING: 'request_reset_loading',
    REQUEST_RESET_SUCCESS: 'request_reset_success',
    REQUEST_RESET_FAIL: 'request_reset_fail',
    HIDE_DROPDOWN: 'hide_dropdown',
    SHOW_DROPDOWN: 'show_dropdown',
    STATS: 'stats',
    STATS_LOADING: 'stats_loading',
    STATS_CHANGE: 'stats_change',
    LOGOUT: 'logout',
    DASHBOARD_OPENED: 'dashboard_opened',
    SIDEBAR_TOGGLE: 'sidebar_toggle',
    GET_JOBS: 'get_jobs',
    JOB_LOADING: 'job_loading',
    DELETE_JOB: 'delete_job',
    ADD_JOB: 'add_job',
    ADD_JOB_FAIL: 'add_job_fail',
    UPDATE_JOB: 'update_job',
    UPDATE_JOB_FAIL: 'update_job_fail',
    GET_TYPES: 'get_types',
    TYPES_LOADING: 'types_loading',
    ADD_TYPE: 'add_type',
    ADD_TYPE_FAIL: 'add_type_fail',
    UPDATE_TYPE: 'update_type',
    UPDATE_TYPE_FAIL: 'update_type_fail',
    DELETE_TYPE: 'delete_type',
    GET_LOCATIONS: 'get_locations',
    LOCATIONS_LOADING: 'locations_loading',
    ADD_LOCATION: 'add_location',
    ADD_LOCATION_FAIL: 'add_location_fail',
    ADD_SUBLOCATION: 'add_sublocation',
    ADD_SUBLOCATION_FAIL: 'add_sublocation_fail',
    UPDATE_LOCATION: 'update_location',
    UPDATE_LOCATION_FAIL: 'update_location_fail',
    DELETE_LOCATION: 'delete_location',
    DELETE_SUBLOCATION: 'delete_sub_location',
    GET_USERS: 'get_users',
    USERS_LOADING: 'users_loading',
    ADD_USER: 'add_user',
    ADD_USER_FAIL: 'add_user_fail',
    UPDATE_USER: 'update_user',
    UPDATE_USER_FAIL: 'update_user_fail',
    DELETE_USER: 'delete_user',
    SEND_DETAILS: 'send_details',
    GET_REPORTS: 'get_reports',
    REPORTS_LOADING: 'reports_loading',
    GET_COMPANIES: 'get_companies',
    COMPANIES_LOADING: 'companies_loading',
    ADD_COMPANY: 'add_company',
    ADD_COMPANY_FAIL: 'add_company_fail',
    UPDATE_COMPANY: 'update_company',
    UPDATE_COMPANY_FAIL: 'update_company_fail',
    DELETE_COMPANY: 'delete_company',
    RESET_JOBS_ALERT: 'reset_jobs_alert',
    RESET_TYPES_ALERT: 'reset_types_alert',
    RESET_USERS_ALERT: 'reset_users_alert',
    RESET_LOCATIONS_ALERT: 'reset_locations_alert',
    RESET_COMPANIES_ALERT: 'reset_companies_alert',
    JOB_SUBMITTED: 'job_submitted',
    TOGGLE_MODAL: 'toggle_modal',
    SET_MODAL_DATA: 'set_modal_data',
  };
  
  export default constants;
  


// WEBPACK FOOTER //
// ./src/Constants/index.js